import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import { useNavigate } from "react-router-dom";

const rubikfont = {
    fontFamily: "Rubik, san-serif"
};

const Layout5 = ({ data }) => {
    const products = data?.product_id || [];
    const colors = ["#8B4513", "#2C5F2D", "#3F51B5", "#8B0000", "#8B4513"];

    const navigate = useNavigate();

    const handleProductClick = (productId) => {
        navigate(`/product/${productId}`);
        window.scrollTo(0, 0);
    };

    return (
        <Box sx={{ bgcolor: "#f8f8f8", py: { xs: 8, md: 12 }, position: "relative", overflow: "hidden" }}>
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "300px",
                    height: "300px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, rgba(34,34,34,0.05), transparent)",
                    transform: "translate(30%, -30%)",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "250px",
                    height: "250px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, transparent, rgba(34,34,34,0.05))",
                    transform: "translate(-30%, 30%)",
                }}
            />

            <Paper sx={{ bgcolor: "transparent", boxShadow: "none", px: { xs: 2, md: 4 } }}>
                {/* Section Header */}
                <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>

                    <Typography
                        sx={{
                            fontSize: { xs: "32px", sm: "48px", md: "56px" },
                            color: "#222",
                            ...rubikfont,
                            fontWeight: 900,
                            lineHeight: 1.1,
                            letterSpacing: "3.5px",
                            textTransform: "uppercase"
                        }}
                    >
                        {data?.title}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: "14px", md: "16px" },
                            color: "#666",
                            mt: 2,
                            maxWidth: "600px",
                            mx: "auto",
                            ...rubikfont,
                        }}
                    >
                        Handpicked combinations for every grooming need
                    </Typography>
                </Box>

                {/* Scrolling Card Wrapper */}
                <Box
                    sx={{
                        overflowX: "auto",
                        overflowY: "hidden",
                        scrollBehavior: "smooth",
                        pb: 2,
                        "&::-webkit-scrollbar": { display: "none" },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            gap: 3,
                            willChange: "transform",
                            animation: "scrollHorizontal 40s linear infinite",
                            "&:hover": {
                                animationPlayState: "paused",
                            },
                        }}
                        className="scrolling-cards"
                    >
                        {products.map((product, index) => {
                            const color = colors[index % colors.length];
                            return (
                                <Box
                                    key={product._id || index}
                                    sx={{
                                        position: "relative",
                                        minWidth: { xs: "80%", sm: "45%", md: "30%" },
                                        borderRadius: 3,
                                        overflow: "hidden",
                                        height: { xs: 220, sm: 260, md: 300 },
                                        cursor: "pointer",
                                        transition: "all 0.5s ease",
                                        boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                                        flexShrink: 0,
                                        "&:hover": {
                                            transform: "translateY(-8px)",
                                            boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
                                            "& .small-collection-image": {
                                                transform: "scale(1.15)",
                                            },
                                            "& .small-overlay": {
                                                background: `linear-gradient(135deg, ${color}dd, ${color}99)`,
                                            },
                                        },
                                    }}
                                >
                                    <img
                                        src={product.product_images?.[0] || "https://via.placeholder.com/300"}
                                        alt={product.title}
                                        className="small-collection-image"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            transition: "transform 0.8s ease",
                                        }}
                                    />
                                      {/* B2B Discount Badge */}
                                                                {product.b2b_discountValue && (
                                                                    <Box
                                                                        sx={{
                                                                            position: "absolute",
                                                                            top: 10,
                                                                            left: 10,
                                                                            bgcolor: "#ffffffff",
                                                                            color: "black",
                                                                            px: 1.5,
                                                                            py: 0.5,
                                                                            borderRadius: 1,
                                                                            fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                                                            fontWeight: 600,
                                                                            ...rubikfont,
                                                                            zIndex: 2,
                                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                                        }}
                                                                    >
                                                                        {product.b2b_discountType === "percentage" 
                                                                            ? `${product.b2b_discountValue}% OFF`
                                                                            : `₹${product.b2b_discountValue} OFF`
                                                                        }
                                                                    </Box>
                                                                )}
                                    <Box
                                        className="small-overlay"
                                        sx={{
                                            position: "absolute",
                                            inset: 0,
                                            background: `linear-gradient(135deg, ${color}cc, ${color}88)`,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-end",
                                            p: 3,
                                            transition: "all 0.5s ease",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "white",
                                                fontSize: { xs: "20px", md: "24px" },
                                                fontWeight: 900,
                                                mb: 0.5,
                                                ...rubikfont,
                                            }}
                                        >
                                            {product.title}
                                        </Typography>
                                        {/*b2b_sellingPrice */}
                                        <Typography
                                            sx={{
                                                color: "rgba(255,255,255,0.95)",
                                                fontSize: { xs: "13px", md: "14px" },
                                                ...rubikfont,
                                                mb: 2,
                                                display: "-webkit-box",
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                            }}
                                        >
                                            ₹{product.b2b_sellingPrice}
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 1,
                                                color: "white",
                                                fontSize: "13px",
                                                fontWeight: 700,
                                                letterSpacing: "1px",
                                                ...rubikfont,
                                                transition: "gap 0.3s ease",
                                                "&:hover": { gap: 2 },
                                            }}
                                            onClick={() => handleProductClick(product._id)}
                                        >
                                            EXPLORE <Box component="span" sx={{ fontSize: "16px" }}>→</Box>
                                        </Box>
                                    </Box>
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
                {/* View All Button */}
                <Box sx={{ textAlign: "center", mt: 6, display: "flex", gap: 3, flexWrap: "wrap", justifyContent: "center" }}>
                    <AnimatedButton text="View All  →" onClick={() => navigate('/search', { state: { layoutId: data._id, title: data.title } })} />
                </Box>
            </Paper>
        </Box>
    );
};

export default Layout5;
